import { render, staticRenderFns } from "./DashMobileAppsDescription.vue?vue&type=template&id=4ade2d92&scoped=true&"
import script from "./DashMobileAppsDescription.vue?vue&type=script&lang=js&"
export * from "./DashMobileAppsDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade2d92",
  null
  
)

export default component.exports